import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

// import { Icon } from '@vallourec-ui/vallourec-ui'

import { Bell } from '../Icons/Bell'
import { BellBadge } from '../Icons/BellBadge'
import {
  Container,
  ContainerIcon,
  NotificationItem,
  NotificationList,
} from './style'
import {
  findUserNotifications as findUserNotificationsPost,
  updateUserNotifications as updateUserNotificationsPost,
} from '@/api/post'
import { useApp } from '@/stores/AppStore'
import { Icon, useAuthSSO } from '@vallourec-ui/vallourec-ui'

interface NotificationsProps {}

const Notifications: React.FC<NotificationsProps> = () => {
  const { isAuthenticated } = useAuthSSO()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)
  const [userNotificationsNews, setUserNotificationsNews] = useState([])
  const [userNotifications, setUserNotifications] = useState([])

  const userLocalStorage = localStorage.getItem('cognito:user')
  const containerRef = useRef(null)

  const { setDocCode } = useApp()

  let userData
  if (userLocalStorage && JSON.stringify(userLocalStorage) !== '{}') {
    userData = JSON.parse(userLocalStorage)
  }

  const findNotificationUser = () => {
    if (userData && userData.email) {
      findUserNotificationsPost({ email: userData.email }).then((data) => {
        setUserNotificationsNews(
          data.filter((item: { viewed: any }) => !item.viewed)
        )
        setUserNotifications(data)
      })
    }
  }

  useEffect(() => {
    if(isAuthenticated){
      findNotificationUser()

      const notificationInterval = setInterval(findNotificationUser, 600000)

      return () => clearInterval(notificationInterval)
    }
  }, [])

  const clickViewedUserNotifications = (code: string) => {
    updateUserNotificationsPost({ code, email: userData.email }).then(
      (data) => {
        setUserNotificationsNews(
          data.filter((item: { viewed: any }) => !item.viewed)
        )
        setUserNotifications(data)
      }
    )
  }

  const redirectApprovalFlow = (code: string) => {
    if (location.pathname === '/approval-flow') {
      setDocCode(code)
    }
    navigate(`/approval-flow?docCode=${code}`)
  }

  const onClickUserNotification = (code: string) => {
    clickViewedUserNotifications(code)
    setIsOpen(false)
    redirectApprovalFlow(code)
  }

  const toggleNotifications = () => {
    setIsOpen(!isOpen)
  }

  const handleClickOutside = (event: any) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <Container ref={containerRef}>
      <ContainerIcon onClick={toggleNotifications}>
        <>
          {userNotificationsNews.length > 0 && (
            <Icon name="BellBadge" width={32} height={32} color='neutral-color-0' />
          )}{' '}
        </>
        <>
          {userNotificationsNews.length === 0 && (
            <Icon name="Bell" width={32} height={32} color='neutral-color-0'/>
          )}{' '}
        </>
      </ContainerIcon>
      {isOpen && (
        <NotificationList>
          {userNotifications.length > 0 ? (
            userNotifications.map((notification, index) => (
              <NotificationItem
                key={index}
                onClick={() => onClickUserNotification(notification.code)}
              >
                {notification.code} - {notification.status}
              </NotificationItem>
            ))
          ) : (
            <NotificationItem key={0}>
              {t<string>('notification.empty')}
            </NotificationItem>
          )}
        </NotificationList>
      )}
    </Container>
  )
}

export default Notifications
